import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';

import { AuthenticationService } from '../_services/authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) {

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    const user = this.authenticationService.currentUserSubject.value;

    if (user) {
      //Check if the desired route is restricted by role and whether the user's role 
      if (route.data.Roles && route.data.roles.indexOf(user.Role) === -1) {
        this.router.navigate(['/']);
        return false;
      }

      return true;
    }

    //If we struck out, clear the current user, and then navigate to the login page
    this.authenticationService.logout();

    this.router.navigate(['/login'], {
      queryParams: {
        returnUrl: state.url
      }
    });

    return false;
  }
}
